import {reactive} from 'vue';
import {useConfig} from '@/helpers/config-effect';

const NOTIFICATIONS = reactive([]);
const ICONS = {'info': 'info', 'success': 'check'};

NOTIFICATIONS.__proto__.add = function (title, body, level = 'info') {
    const notification = {
        icon: ICONS[level] || 'info',
        color: level,
        title,
        body
    };
    notification.timeout = setTimeout(
        () => NOTIFICATIONS.splice(NOTIFICATIONS.indexOf(notification), 1),
        3000
    );

    NOTIFICATIONS.push(notification);
};

const config = useConfig();

const STORE = reactive({
    expandedNode: '',
    currentActiveNodes: [],
    workflow: null,
    isVariableFinderVisible: false,
    notifications: NOTIFICATIONS,
    connections: config.connections
});

export function useStore() {
    return STORE;
}
